import React from "react";
import { BrowserRouter as Router } from 'react-router-dom';
import { GlobalStyle } from './styles/globalStyles';
import Hero from './components/Hero';
import Welcome from './components/Welcome';
import Rarity from './components/Rarity';
import Footer from './components/Footer';
import FAQ from './components/FAQ';
import Roadmap from './components/Roadmap';
import Community from './components/Community';

function App() {
  return (
    <Router>
      <GlobalStyle />
      <Hero />
      <Welcome />
      <Rarity />
      <FAQ />
      <Roadmap />
      <Community />
      {/*<Products heading='Choose your Bear' data={productData} />
      <Products heading='Sweet Treats for You' data={productDataTwo} />*/}
      <Footer />
    </Router>
  );
}

export default App;
